import React, {Component} from "react";
import {CAMPAIGN_STATUS_ACTIVE} from "../../../marketing";
import {BusinessUnitShowAdAccountsOrCampaignsTooltip} from "../BusinessUnitShowAdAccountsOrCampaignsTooltip";

export class CampaignNameCell extends Component {

    renderStatus() {
        if(this.props.status !== CAMPAIGN_STATUS_ACTIVE)
            return <span className="ml-2 mr-2  status_not_active">[No activa]</span>
    }

    render() {
        return (
            <td>
                <div className="bu-cell ad_account_row">
                    <div className="bu-name-with-tooltip">
                        <div className="campaign-name" title={this.props.campaignName}>
                            {this.props.campaignName}{this.renderStatus()}
                        </div>
                    </div>
                    <div className="some-icons">
                        {this.renderToggleDetails()}
                    </div>
                </div>
            </td>
        );
    }

    renderToggleDetails() {
        // const tooltipMessage = !this.props.hasAdAccountsDataToShow ? "Hay una sola cuenta publicitaria configurada en el presupuesto." : null;

        if(!this.props.hasAdgroupsData)
            return;

        const tooltipMessage = null;

        return <BusinessUnitShowAdAccountsOrCampaignsTooltip key="bu-show-ad-accounts-icon"
                                                             message={tooltipMessage}
                                                             onClick={() => this.props.onAdgroupsDataToggle(this.props.campaignId)}
            // enabled={this.props.hasAdAccountsDataToShow}
                                                             enabled={true}
                                                             isShowing={false}
        />
    }


}
